var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.491593,
    y: 0.15825,
    width: 23.0168,
    height: 15.6835,
    rx: 1.74075,
    fill: "#1F72CD",
    stroke: "#F6F6F4",
    strokeWidth: 0.3165
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51649 5.66669L2.33337 10.4978H4.94687L5.27087 9.72756H6.01145L6.33545 10.4978H9.21217V9.90994L9.46851 10.4978H10.9566L11.2129 9.89752V10.4978H17.1957L17.9232 9.74756L18.6044 10.4978L21.6773 10.5041L19.4873 8.09576L21.6773 5.66669H18.652L17.9439 6.40311L17.2841 5.66669H10.7756L10.2167 6.91365L9.64475 5.66669H7.03671V6.23459L6.74658 5.66669H4.51649ZM5.02218 6.35275H6.29611L7.74418 9.62879V6.35275H9.13973L10.2582 8.70165L11.289 6.35275H12.6776V9.81943H11.8326L11.8257 7.10296L10.5939 9.81943H9.83811L8.5994 7.10296V9.81943H6.86122L6.53169 9.04224H4.75137L4.42252 9.81874H3.49122L5.02218 6.35275ZM16.8862 6.35275H13.4506V9.81738H16.833L17.9232 8.66915L18.974 9.81738H20.0724L18.4758 8.0951L20.0724 6.35275H19.0216L17.937 7.4878L16.8862 6.35275ZM5.64189 6.93928L5.05535 8.32376H6.22776L5.64189 6.93928ZM14.299 7.70335V7.07051V7.0699H16.4427L17.3781 8.08198L16.4012 9.09958H14.299V8.4087H16.1732V7.70335H14.299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.e7d46b5dee8ba0e0a3ae93c6cb813039.svg";
export { ForwardRef as ReactComponent };